const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * UserAssessments Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('AssessmentHost', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/assessment-host/:subresource/:subname/:subsubresource/:subsubname', null, {
    rubricChart: {params: {subname: 'rubric-chart'}, method: 'GET', isArray: false},
    standardChart: {params: {subname: 'standard-chart'}, method: 'GET', isArray: false},
    overviewStats: {params: {subresource: 'overview-stats'}, method: 'GET', isArray: false}
  });
}]);